import React, { useState, useEffect, useCallback } from "react";
import { Container, Box, Paper } from "@mui/material";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import FinalStep from "./FinalStep";
import {
  getNoOfVehicleCount,
  getVehicleTypeCall,
  getMaterialTypeCall,
} from "../../services/VendorAppointmentBook";
import { useNotificationContext } from "../../common/NotificationContext";
import { useLoading } from "../../common/LoadingContext";
import useGlobalState from "../../Context";
import { setMaterialList, setVehicleList } from "../../reducer/action";
import HoldBookingDialog from "./HoldBookingDialog";
import { useNavigate } from "react-router-dom";
import { appointmentConstant } from "../../utils/appointmentConstant";

const baseUrl = process.env.REACT_APP_BASE_URL;
const getSteps = () => {
  return ["step 1", "step 2", "step 3", "step 4"];
};
const steplabel = [
  "PO Details",
  "Vendor Details",
  "Select Appointment",
  "Preview",
];
const VendorAppointment = () => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = useState({});
  const [formData, setFormData] = useState({});
  const [noOfVehicle, setNoOfVehicle] = useState(0);
  const [appointmentTimeSlots, setAppointmentTimeSlots] = useState([]);
  const [appointmentStore, setAppointmentStore] = useState({});
  const [{ vehicleList, materialList }, dispatch] = useGlobalState();
  const [inputTypeList] = useState([
    { inputTypeId: 1, inputTypeName: "PO" },
    { inputTypeId: 2, inputTypeName: "ASN" },
  ]);
  const [holdBooking, setHoldBooking] = useState(false);
  const [uniqueAppointmentTimeSlots, setUniqueAppointmentTimeSlots] = useState(
    []
  );
  const [showCase, setShowCase] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [next, setNext] = useState(false);
  const [nextEnable, setNextEnable] = useState(false);
  const [strategy, setStrategy] = useState(appointmentConstant.TOTAL_BOX_COUNT);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [articles, setArticles] = useState([]);
  const [selectedArticles, setSelectedArticles] = useState([]);
  const [isSelectCheckBox, setIsSelectCheckBox] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [config, setConfig] = useState({});
  const [siteConfig, setSiteConfig] = useState({});
  const navigate = useNavigate();
  const steps = getSteps();
  const [deliveryBookingWindow, setDeliveryBookingWindow] = useState(0);
  const [diffDaysArray, setDiffDaysArray] = useState([]);
  const [deliveryDateArray, setDeliveryDateArray] = useState([]);
  const [subFormatCode, setSubFormatCode] = useState(null);
  const [listOfPO, setListOfPO] = useState([]);
  const [deliveryDateArray1, setDeliveryDateArray1] = useState([]);
  const [orderType, setOrderType] = useState(1);

  const holdBookingHandler = useCallback(() => {
    setHoldBooking(true);
  }, []);

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Step1
            onClickNext={handleComplete}
            formData={formData}
            holdBooking={holdBookingHandler}
            setFormData={setFormData}
            handleBack={handleBack}
            inputTypeList={inputTypeList}
            materialTypeList={materialList ?? []}
            showCase={showCase}
            setShowCase={setShowCase}
            next={next}
            setNext={setNext}
            nextEnable={nextEnable}
            setNextEnable={setNextEnable}
            strategy={strategy}
            setStrategy={setStrategy}
            showFilter={showFilter}
            setShowFilter={setShowFilter}
            dialogOpen={dialogOpen}
            setDialogOpen={setDialogOpen}
            articles={articles}
            setArticles={setArticles}
            selectedArticles={selectedArticles}
            setSelectedArticles={setSelectedArticles}
            isSelectCheckBox={isSelectCheckBox}
            setIsSelectCheckBox={setIsSelectCheckBox}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            setConfig={setConfig}
            setNoOfVehicle={setNoOfVehicle}
            setDeliveryBookingWindow={setDeliveryBookingWindow}
            diffDaysArray={diffDaysArray}
            setDiffDaysArray={setDiffDaysArray}
            deliveryDateArray={deliveryDateArray}
            setDeliveryDateArray={setDeliveryDateArray}
            setAppointmentStore={setAppointmentStore}
            setSubFormatCode={setSubFormatCode}
            subFormatCode={subFormatCode}
            setSiteConfig={setSiteConfig}
            setListOfPO={setListOfPO}
            deliveryDateArray1={deliveryDateArray1}
            setDeliveryDateArray1={setDeliveryDateArray1}
            orderType={orderType}
            setOrderType={setOrderType}
          />
        );
      case 1:
        return (
          <Step2
            onClickNext={handleComplete}
            formData={formData}
            noOfVehicle={noOfVehicle}
            setFormData={setFormData}
            handleBack={handleBack}
            vehicleTypeList={vehicleList ?? []}
            strategy={strategy}
            setStrategy={setStrategy}
          />
        );
      case 2:
        return (
          <Step3
            appointmentStore={appointmentStore}
            setAppointmentStore={setAppointmentStore}
            onClickNext={handleComplete}
            formData={formData}
            setFormData={setFormData}
            handleBack={handleBack}
            uniqueAppointmentTimeSlots={uniqueAppointmentTimeSlots}
            setUniqueAppointmentTimeSlots={setUniqueAppointmentTimeSlots}
            appointmentTimeSlots={appointmentTimeSlots}
            materialTypeList={materialList ?? []}
            setAppointmentTimeSlots={setAppointmentTimeSlots}
            strategy={strategy}
            setStrategy={setStrategy}
            config={config}
            deliveryBookingWindow={deliveryBookingWindow}
            siteConfig={siteConfig}
            listOfPO={listOfPO}
          />
        );
      case 3:
        return (
          <FinalStep
            onClickNext={handleComplete}
            formData={formData}
            setFormData={setFormData}
            handleBack={handleBack}
            materialTypeList={materialList ?? []}
            vehicleTypeList={vehicleList ?? []}
            strategy={strategy}
            setStrategy={setStrategy}
          />
        );
      default:
        return (
          <Step1
            onClickNext={handleComplete}
            holdBooking={holdBookingHandler}
            formData={formData}
            setFormData={setFormData}
            handleBack={handleBack}
          />
        );
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const getMaxVehicleCount = useCallback(async () => {
    try {
      setLoading(true);
      const resp = await getNoOfVehicleCount(baseUrl);
      if (resp?.messageCode === 6) {
        setNoOfVehicle(resp.maxVehicles);
      } else {
        showNotification(
          "Error",
          resp?.message ?? "Failed to Fetch Max Vehicle Count"
        );
        setNoOfVehicle([]);
      }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed to Fetch Max Vehicle Count"
      );
    } finally {
      setLoading(false);
    }
  }, [setLoading, showNotification]);
  const getVehicleType = useCallback(async () => {
    try {
      setLoading(true);
      const resp = await getVehicleTypeCall(baseUrl);
      if (resp?.messageCode === 6) {
        dispatch(setVehicleList(resp.vehicleTypeParams));
      } else {
        showNotification(
          "Error",
          resp?.message ?? "Failed To Get Vehicle Type"
        );
        dispatch(setVehicleList(resp.vehicleTypeParams));
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Get Vehicle Type");
    } finally {
      setLoading(false);
    }
  }, [dispatch, setLoading, showNotification]);
  const getMaterialType = useCallback(async () => {
    try {
      setLoading(true);
      const resp = await getMaterialTypeCall(baseUrl);
      if (resp?.messageCode === 6) {
        dispatch(setMaterialList(resp.materialTypeParams));
      } else {
        showNotification(
          "Error",
          resp?.message ?? "Failed To Get Material Type"
        );
        dispatch(setMaterialList(resp.materialTypeParams));
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Get Material Type");
    } finally {
      setLoading(false);
    }
  }, [dispatch, setLoading, showNotification]);

  const initialLoad = useCallback(async () => {
    await getMaxVehicleCount();
    if (
      vehicleList === undefined ||
      vehicleList === null ||
      vehicleList?.length === 0
    ) {
      await getVehicleType();
    }
    if (
      materialList === undefined ||
      materialList === null ||
      materialList?.length === 0
    ) {
      await getMaterialType();
    }
  }, [
    getMaterialType,
    getMaxVehicleCount,
    getVehicleType,
    materialList,
    vehicleList,
  ]);

  useEffect(() => {
    initialLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container maxWidth="xl" sx={{ mt: 8, px: 1 }} disableGutters>
      <Box display={"flex"} justifyContent="center" mx={3} pb={1} pt={3}>
        <Paper elevation={6} className="appointment_container">
          <div>
            <Box sx={{ width: "100%" }}>
              <div className="appointment_header_bar">
                <div className="appointment_title">
                  <CalendarMonthIcon fontSize="large" />
                  <br />
                  {activeStep === 3
                    ? "Vendor Appointment Preview"
                    : "Appointment Booking"}
                </div>
                <div className="appointment_stepper">
                  <Stepper
                    activeStep={activeStep}
                    alternativeLabel
                    className="stepMain"
                  >
                    {steps.map((label, index) => {
                      const stepProps = {};
                      const labelProps = {};
                      return (
                        <Step key={index} {...stepProps}>
                          <StepLabel {...labelProps}>
                            <span className="stepLabel">{label}</span>
                            <br />
                            <span className="stepsubLabel">
                              {" "}
                              {steplabel[index]}
                            </span>
                          </StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                </div>
              </div>
              {getStepContent(activeStep)}
            </Box>
          </div>
        </Paper>
      </Box>
      <HoldBookingDialog
        open={holdBooking}
        handleClose={() => {
          setHoldBooking(false);
          navigate("/");
        }}
      />
    </Container>
  );
};

export default VendorAppointment;
